import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import useStyles from './styles';
import i18n from '../../../i18n';

export default function ProfilePage(props) {
  const classes = useStyles();
  const { site, role, roleGn, roleFr } = props;
  const { t } = useTranslation();
  const lang = i18n.language;

  function getUserRole() {
    if (lang === 'en') {
      return role;
    }
    if (lang === 'fr') {
      return roleFr;
    }
    if (lang === 'de') {
      return roleGn;
    }
    return role;
  }
  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Typography className={classes.title}> {t('Profile')}</Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <div className={classes.helpDiv} data-testid="profile-page-block">
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                <Typography className={classes.titleMedium}>
                  {' '}
                  {t('Role')}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography className={classes.detailText}>
                  {getUserRole()}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={3}>
                <Typography className={classes.titleMedium}>
                  {' '}
                  {t('Site')}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography className={classes.detailText}>{site}</Typography>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Grid>
    </div>
  );
}
